// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThO5oHBfyprkItCFJQQN {
    height: 100%;
}

.HJNjnlTawnG_XfcGBzRU {
    background-color: #f5fbfc;
    border: none;
    border-bottom: 1px solid;
    border-color: grey;

    margin-left: -16px;
    padding-left: 32px;
    padding-top: 16px;
}

.UMyGMUlrCWXuGGNnDeKV, .NIgtzks63w4Djasnsx5A {
    display: flex;
    align-items: center;
}

.ycPg2rjHCGdKVldJTA85 {
    font-size: 20px;
}

.LEAHERTHakY81wevwLeB {
    display: inline-block;
    font-size: 20px;
    max-width: 300px;
    text-overflow: ellipsis;
    height: 32px;
    white-space: nowrap;
}

.LEAHERTHakY81wevwLeB + .LEAHERTHakY81wevwLeB {
    margin-left: 16px;
}

.vACcI5tciA7dY98o7yDH {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.GRQW_NAU8K30uJRJieQo {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    max-width: 380px;
    margin: 0 16px 5px 0;
}

.GRQW_NAU8K30uJRJieQo input {
    font-size: 14px;
}

.b1tnjMl4635edumtYU50 {
    width: 200px;
    height: 35px;
    background-color: white;
    border-radius: 5px;
    font-size: 14px;
    padding-left: 5px;
    padding-right: 5px;
}

.XsNFAw1433GG86opIyWc {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
@media only screen and (max-width: 800px) {
    .XsNFAw1433GG86opIyWc {
        flex-direction: column;
    }
}


.dqpHOxmsnRC61WMPUyYm {
    display: flex;
    overflow: auto;
    height: 100%;
    max-height: calc(100% - 150px);
}

@media screen and (max-width: 800px) {
    .dqpHOxmsnRC61WMPUyYm {
        max-height: calc(100% - 220px);
    }
}

.RKrd4YADBt6Guhlvmurn {
    font-size: 12px;
    color: grey;
    margin-left: 16px;
}

.Tq3a0fK6Of5CTIXuAjGD {
    margin-top: 16px;
    width: 30%;
}


.e0BJU7aPXyV0VmlxWl5u {
    padding: 16px;
    width: 100%;
}

.B8h_pxDi2cs7daFJe9io {
    text-transform: none;
    font-size: 14px;
    padding: 6px 14px;
    font-weight: 400;
    border-radius: 5px;
}

.CYx1gqG1tv0OQEFC7Gpn {
    padding: 0 6px;
}


.A97GjWK9eFxeR2evYcsB {
    border-bottom: 0;
    font-size: 90%;
    font-weight: 600;
}

.A97GjWK9eFxeR2evYcsB > li > a {
    background-color: transparent;
    color: black;
}

.A97GjWK9eFxeR2evYcsB > li {
    margin-bottom: 0px;
    background-color: transparent;
}

.A97GjWK9eFxeR2evYcsB > li > a:hover {
    background-color: transparent;
    border-color: transparent;
}

.A97GjWK9eFxeR2evYcsB > li.active > a {
    border-color: #5bb3c4;
    border-style: solid;
    border-width: 0 0 2px 0;
    background-color: transparent;
    color: #5bb3c4;
}

.A97GjWK9eFxeR2evYcsB > li.active > a:focus {
    /* overrides bootstrap */
    border: none;
    border-color: #5bb3c4;
    border-style: solid;
    border-width: 0 0 2px 0;
    background-color: transparent;
    color: #5bb3c4;
}

.A97GjWK9eFxeR2evYcsB > li.active > a:hover {
    /* overrides bootstrap */
    border: none;
    border-color: #5bb3c4;
    border-style: solid;
    border-width: 0 0 2px 0;
    background-color: transparent;
    color: #5bb3c4;
}

.R4a4CyuvfGv6izffaKp1 {
    margin: 0 0 13px 8px;
    transform: scale(80%);
}

.R4a4CyuvfGv6izffaKp1 span {
    color: white;
}

.dqpHOxmsnRC61WMPUyYm .panel {
    margin-bottom: initial;
    background-color: initial;
    border: initial;
    border-radius: initial;
    -webkit-box-shadow: initial;
    box-shadow: initial;
}

.dqpHOxmsnRC61WMPUyYm .panel-body {
    padding: initial;
}

.dqpHOxmsnRC61WMPUyYm .panel-heading {
    display: none;
}

.dqpHOxmsnRC61WMPUyYm #navContainer {
    margin-top: -16px;
}

.dqpHOxmsnRC61WMPUyYm .table {
    margin: 5px 0 45px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/interests-profile-slideout/components/index.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;;IAElB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,OAAO;IACP,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI;QACI,sBAAsB;IAC1B;AACJ;;;AAGA;IACI,aAAa;IACb,cAAc;IACd,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;;AAGA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".profile {\n    height: 100%;\n}\n\n.header {\n    background-color: #f5fbfc;\n    border: none;\n    border-bottom: 1px solid;\n    border-color: grey;\n\n    margin-left: -16px;\n    padding-left: 32px;\n    padding-top: 16px;\n}\n\n.labels, .controls {\n    display: flex;\n    align-items: center;\n}\n\n.fa-star {\n    font-size: 20px;\n}\n\n.label {\n    display: inline-block;\n    font-size: 20px;\n    max-width: 300px;\n    text-overflow: ellipsis;\n    height: 32px;\n    white-space: nowrap;\n}\n\n.label + .label {\n    margin-left: 16px;\n}\n\n.navigation {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.actionbuttons {\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    max-width: 380px;\n    margin: 0 16px 5px 0;\n}\n\n.actionbuttons input {\n    font-size: 14px;\n}\n\n.selectStatus {\n    width: 200px;\n    height: 35px;\n    background-color: white;\n    border-radius: 5px;\n    font-size: 14px;\n    padding-left: 5px;\n    padding-right: 5px;\n}\n\n.actions {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n@media only screen and (max-width: 800px) {\n    .actions {\n        flex-direction: column;\n    }\n}\n\n\n.container {\n    display: flex;\n    overflow: auto;\n    height: 100%;\n    max-height: calc(100% - 150px);\n}\n\n@media screen and (max-width: 800px) {\n    .container {\n        max-height: calc(100% - 220px);\n    }\n}\n\n.metadata {\n    font-size: 12px;\n    color: grey;\n    margin-left: 16px;\n}\n\n.sidebar {\n    margin-top: 16px;\n    width: 30%;\n}\n\n\n.content {\n    padding: 16px;\n    width: 100%;\n}\n\n.dropdownBtn {\n    text-transform: none;\n    font-size: 14px;\n    padding: 6px 14px;\n    font-weight: 400;\n    border-radius: 5px;\n}\n\n.divider {\n    padding: 0 6px;\n}\n\n\n.sections {\n    border-bottom: 0;\n    font-size: 90%;\n    font-weight: 600;\n}\n\n.sections > :global(li > a) {\n    background-color: transparent;\n    color: black;\n}\n\n.sections > li {\n    margin-bottom: 0px;\n    background-color: transparent;\n}\n\n.sections > li > a:hover {\n    background-color: transparent;\n    border-color: transparent;\n}\n\n.sections > :global(li.active > a) {\n    border-color: #5bb3c4;\n    border-style: solid;\n    border-width: 0 0 2px 0;\n    background-color: transparent;\n    color: #5bb3c4;\n}\n\n.sections > :global(li.active > a:focus) {\n    /* overrides bootstrap */\n    border: none;\n    border-color: #5bb3c4;\n    border-style: solid;\n    border-width: 0 0 2px 0;\n    background-color: transparent;\n    color: #5bb3c4;\n}\n\n.sections > :global(li.active > a:hover) {\n    /* overrides bootstrap */\n    border: none;\n    border-color: #5bb3c4;\n    border-style: solid;\n    border-width: 0 0 2px 0;\n    background-color: transparent;\n    color: #5bb3c4;\n}\n\n.badge {\n    margin: 0 0 13px 8px;\n    transform: scale(80%);\n}\n\n.badge span {\n    color: white;\n}\n\n.container :global(.panel) {\n    margin-bottom: initial;\n    background-color: initial;\n    border: initial;\n    border-radius: initial;\n    -webkit-box-shadow: initial;\n    box-shadow: initial;\n}\n\n.container :global(.panel-body) {\n    padding: initial;\n}\n\n.container :global(.panel-heading) {\n    display: none;\n}\n\n.container :global(#navContainer) {\n    margin-top: -16px;\n}\n\n.container :global(.table) {\n    margin: 5px 0 45px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile": `ThO5oHBfyprkItCFJQQN`,
	"header": `HJNjnlTawnG_XfcGBzRU`,
	"labels": `UMyGMUlrCWXuGGNnDeKV`,
	"controls": `NIgtzks63w4Djasnsx5A`,
	"fa-star": `ycPg2rjHCGdKVldJTA85`,
	"faStar": `ycPg2rjHCGdKVldJTA85`,
	"label": `LEAHERTHakY81wevwLeB`,
	"navigation": `vACcI5tciA7dY98o7yDH`,
	"actionbuttons": `GRQW_NAU8K30uJRJieQo`,
	"selectStatus": `b1tnjMl4635edumtYU50`,
	"actions": `XsNFAw1433GG86opIyWc`,
	"container": `dqpHOxmsnRC61WMPUyYm`,
	"metadata": `RKrd4YADBt6Guhlvmurn`,
	"sidebar": `Tq3a0fK6Of5CTIXuAjGD`,
	"content": `e0BJU7aPXyV0VmlxWl5u`,
	"dropdownBtn": `B8h_pxDi2cs7daFJe9io`,
	"divider": `CYx1gqG1tv0OQEFC7Gpn`,
	"sections": `A97GjWK9eFxeR2evYcsB`,
	"badge": `R4a4CyuvfGv6izffaKp1`
};
export default ___CSS_LOADER_EXPORT___;
